<template lang="pug">
  .panel-page-white
    .panel-white.mx-auto.body-1
      FormErrorAlert(
        v-show="message"
        :message="message"
        @dismiss="message = ''"
      )
      PageHeader Receipt Transaction ID Lookup
      form(
        @submit.prevent="search"
        autocomplete="off"
      )
        .lookup-panel.mt-3
          p To find NPLEx transactions, you can enter NPLEx Transaction ID or the Store Transaction ID. Store Transaction ID searches may return multiple results.
          .row
            .col-5
              .form-group
                label(for='transaction_id' required) Transaction ID
                input.form-control(
                  v-model="transactionId"
                  :class="{'is-invalid': transactionIdInvalid}"
                )
          button.btn.btn-primary.mb-5(type="submit") Search
</template>

<script>
import PageHeader from '@/components/PageHeader'
import FormErrorAlert from '@/components/FormErrorAlert'
import * as validation from '@/lib/validation'
import stdmsg from '@/lib/stdmsg'
import { loadForm, clearForm } from '@/lib/formstore'
import { globalError, waitReport } from '@/lib/utils'
import axios from '@/lib/axios'

export default {
  name: 'TransactionLookup',
  data: function() {
    return {
      message: '',
      transactionId: '',
      ...validation.mapTouched(['transactionId']),
    }
  },
  methods: {
    search() {
      this.transactionIdTouched = true
      if (this.transactionIdInvalid) {
        this.message = stdmsg.formError
        return
      }
      // this.$router.push({ name: 'transaction_results' })
      axios()
        .post('/api/transaction_id/search', { id: this.transactionId })
        .then(resp => {
          waitReport(resp.data.id, {
            name: 'transaction_results',
            params: { id: resp.data.id },
          })
        })
    },
  },
  computed: { ...validation.mapRequired(['transactionId']) },
  components: {
    PageHeader,
    FormErrorAlert,
  },
  mounted: loadForm('transactionid', 'transactionId'),
  beforeRouteLeave(to, _from, next) {
    if (to.name !== 'transaction_results') clearForm('transactionid')
    next()
  },
}
</script>

<style lang="scss" scoped>
.lookup-panel {
  background-color: white;
  border: 1px solid #e6e6e6;
  padding: 1rem;
}
</style>
